import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store ={
  namespaced: true,
  state:{ //状态对象：共享值的集合
    info:{},
    details:{}
  },
  mutations:{  //同步修改
    setInfo(state, obj){//初始化
      state.info = obj;
    },
    setDetails(state, obj){//初始化
      state.details = obj;
    },
  },
  getters:{//监测状态
    getInfo:(state)=>{
      return state.info
    },
    getDetails:(state)=>{
      return state.details
    },
  },
  actions:{//异步修改
    addInfo(context,obj={}){ //context 上下文对象，同管全局
      context.commit('setInfo',obj); //上下文对象调用commit执行add方法
    },
    updateInfo(context) { //context 上下文对象，同管全局
      return new Promise((resolve, reject) => {
        window.$apis.filingServer.queryAccountInfo.then((res) => {
          if (res['code'] == 0) {
            context.commit('setInfo', res['data']); //上下文对象调用commit执行add方法
            resolve(res['data']);
          } else {
            reject(res['msg']);
          }
        })
      })
    },
    addDetails(context,obj={}){ //context 上下文对象，同管全局
      context.commit('setDetails',obj); //上下文对象调用commit执行add方法
    },
  }
}

export default store

